import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { Route, Routes } from "react-router-dom";
import PassGen from "./pages/PassGen";
import Login from "./pages/Login";
import HeaderLayout from "./partials/layouts/HeaderLayout";
import PrivateRoute from "./routes/PrivateRoute";
import AuthRoute from "./routes/AuthRoute";

const theme = createTheme({
  typography: {
    fontFamily: "Encode Sans",
    fontSize: 14,
    button: {
      textTransform: "none"
    },
    body2: {
      fontFamily: "Arial",
      color: "gray"
    }
  },
  palette: {
    primary: {
      main: "#BFA66E",
      contrastText: "#ffffff"
    }
  }
});

function App(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <main>
        <Routes>
          <Route path="/login" element={<AuthRoute component={Login} />} />
          <Route element={<HeaderLayout />}>
            <Route path="/" element={<PrivateRoute component={PassGen} />} />
          </Route>
        </Routes>
      </main>
      <ToastContainer />
    </ThemeProvider>
  );
}

export default App;
